module.exports = __webpack_public_path__ + "static/media/large-van_2x.240f23d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/large-van_2x.png
// module id = 666
// module chunks = 27